import React from "react";
import PropTypes from "prop-types";
import { Button, Grid } from "@material-ui/core";
import { v4 } from "uuid";
import useStyles from "./styles";

export default function Stepper({ steps, isAProcess }) {
  const { container, stepButton, activeButton, currentStepButton } =
    useStyles(isAProcess);
  const currentIndex = steps.findIndex(({ isCurrent }) => isCurrent);
  return (
    <Grid container item xs={12} justify="center" className={container}>
      {steps.map(({ title, action, active, isCurrent }, i) => (
        <Button
          key={v4()}
          onClick={() => {
            if (i < currentIndex) {
              action();
            }
          }}
          variant="outlined"
          className={`${stepButton} ${active && activeButton} ${
            isCurrent && currentStepButton
          }`}
          disableTouchRipple={isAProcess}
          disabled={i > currentIndex}
        >
          {title}
        </Button>
      ))}
    </Grid>
  );
}

Stepper.defaultProps = {
  isAProcess: false,
};

Stepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      action: PropTypes.func,
      active: PropTypes.bool,
      isCurrent: PropTypes.bool,
    })
  ).isRequired,
  isAProcess: PropTypes.bool,
};
